var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "#fff",
      display: "block"
    },
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ldio-f10w3fp99r-filter",
    x: "-100%",
    y: "-100%",
    width: "300%",
    height: "300%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    result: "cutoff"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 60,
    intercept: -40
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ldio-f10w3fp99r-filter)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    repeatCount: "indefinite",
    dur: "7.692307692307692s",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 0,
    fill: "#fe718d",
    transform: "scale(0.5)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: 2.564102564102564,
    keySplines: "0.7666666666666666 0 0.6666666666666666 1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 1,
    fill: "#fe718d",
    transform: "scale(0.5)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: 2.564102564102564,
    keySplines: "0.7333333333333333 0 0.6333333333333333 1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#fe718d",
    transform: "scale(0.5)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: 2.564102564102564,
    keySplines: "0.7 0 0.6 1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#fe718d",
    transform: "scale(0.5)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: 2.564102564102564,
    keySplines: "0.6666666666666666 0 0.5666666666666667 1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 4,
    fill: "#fe718d",
    transform: "scale(0.5)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: 2.564102564102564,
    keySplines: "0.6333333333333333 0 0.5333333333333333 1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5,
    fill: "#fe718d",
    transform: "scale(0.5)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: 2.564102564102564,
    keySplines: "0.6 0 0.5 1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#fe718d",
    transform: "scale(0.5)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: 2.564102564102564,
    keySplines: "0.5666666666666667 0 0.4666666666666667 1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 7,
    fill: "#fe718d",
    transform: "scale(0.5)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: 2.564102564102564,
    keySplines: "0.5333333333333333 0 0.43333333333333335 1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 8,
    fill: "#fe718d",
    transform: "scale(0.5)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: 2.564102564102564,
    keySplines: "0.5 0 0.4 1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 9,
    fill: "#fe718d",
    transform: "scale(0.5)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: 2.564102564102564,
    keySplines: "0.4666666666666667 0 0.36666666666666664 1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 10,
    fill: "#fe718d",
    transform: "scale(0.5)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: 2.564102564102564,
    keySplines: "0.43333333333333335 0 0.3333333333333333 1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 11,
    fill: "#fe718d",
    transform: "scale(0.5)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: 2.564102564102564,
    keySplines: "0.4 0 0.3 1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 12,
    fill: "#fe718d",
    transform: "scale(0.5)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: 2.564102564102564,
    keySplines: "0.3666666666666667 0 0.26666666666666666 1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 13,
    fill: "#fe718d",
    transform: "scale(0.5)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: 2.564102564102564,
    keySplines: "0.33333333333333337 0 0.23333333333333334 1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 14,
    fill: "#fe718d",
    transform: "scale(0.5)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: 2.564102564102564,
    keySplines: "0.30000000000000004 0 0.2 1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 15,
    fill: "#fe718d",
    transform: "scale(0.5)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: 2.564102564102564,
    keySplines: "0.26666666666666666 0 0.16666666666666666 1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 16,
    fill: "#fe718d",
    transform: "scale(0.5)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: 2.564102564102564,
    keySplines: "0.23333333333333334 0 0.13333333333333333 1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 17,
    fill: "#fe718d",
    transform: "scale(0.5)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: 2.564102564102564,
    keySplines: "0.2 0 0.1 1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 18,
    fill: "#fe718d",
    transform: "scale(0.5)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: 2.564102564102564,
    keySplines: "0.16666666666666669 0 0.06666666666666667 1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 19,
    fill: "#fe718d",
    transform: "scale(0.5)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: 2.564102564102564,
    keySplines: "0.13333333333333333 0 0.03333333333333333 1",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.bb072a67c9820859e39ae194adebc9fd.svg";
export { ForwardRef as ReactComponent };